import PaymentMethodLogo from "../PaymentMethodLogo/PaymentMethodLogo";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import {
    DepositQRCodeMobileAmountStyled,
    DepositQRCodeMobileDescriptionStyled,
    DepositQRCodeMobileContentTitleStyled,
    DepositQRCodeMobileContentStyled,
    DepositQRCodeMobileStyled,
    DepositQRCodeMobileTotalAmountStyled,
    DepositQRCodeMobileStepsStyled,
    DepositQRCodeMobileSubmitButtonWrapperStyled
} from "./styled/DepositQRCodeMobileStyled";
import amountFormat from "../../../../utils/amountFormat";
import CashierSteps from "../CashierSteps/CashierSteps";
import { DEPOSIT_QR_CODE_STEPS } from "./depositQRCodeConstants";
import { BinIcon } from "../../../../components/icon/Icon";
import { Button } from "react-bootstrap";
import { useCallback, useEffect } from "react";
import { logAppsflyerAction } from "../../../../app/appActions";
import { LOG_AF_EVENT_NAMES } from "../../../../app/appConstants";
import { useGTMEvent } from "../../../GoogleTagManager/googleTagManagerHooks";
import { useDispatch } from "react-redux";
import { openNotificationAction } from "../../../Notifications/notificationsActions";
import DepositQRCodeCopiedNotification from "./DepositQRCodeCopiedNotification";

function DepositQRCodeMobile(props) {
    const dispatch = useDispatch();
    const {getLangPath} = useLangContext();
    const {bonusAmount, onUnMountHandler, payload, selectedPayment, totalAmount} = props;
    const {handleGTMClick} = useGTMEvent({module: 'Cashier'});

    const handleCopyToClipboard = useCallback(() => {
        navigator.clipboard.writeText(payload.qr_code_code).then();
        handleGTMClick({button: 'copy_pix_key'});
        dispatch(logAppsflyerAction({name: LOG_AF_EVENT_NAMES.CASHIER_PIX_KEY_COPY}));
        dispatch(openNotificationAction({
            content: <DepositQRCodeCopiedNotification/>,
            options: {
                autoClose: true,
                position: 'bottom-center',
            }
        }));
    }, [payload, handleGTMClick, dispatch]);

    useEffect(() => {
        return () => {
            onUnMountHandler && onUnMountHandler()
        }
    }, [onUnMountHandler]);

    return <DepositQRCodeMobileStyled>
        <PaymentMethodLogo paymentKey={selectedPayment?.key}/>
        <DepositQRCodeMobileDescriptionStyled>
            {getLangPath('deposit.top_up_via_method', {payment_name: selectedPayment?.label})}
        </DepositQRCodeMobileDescriptionStyled>
        {
            payload?.amount > 0 &&
            <DepositQRCodeMobileAmountStyled>
                {selectedPayment?.currency_notional?.unit || ''}{amountFormat(payload.amount / 100, 2)}
            </DepositQRCodeMobileAmountStyled>
        }
        {
            bonusAmount > 0 &&
            <DepositQRCodeMobileTotalAmountStyled>
                <span>{getLangPath('deposit.total_amount_with_bonus')}</span>
                <span>{`$${amountFormat(totalAmount, 2)}`}</span>
            </DepositQRCodeMobileTotalAmountStyled>
        }
        <DepositQRCodeMobileContentStyled>
            <DepositQRCodeMobileContentTitleStyled>
                {getLangPath('deposit.how_top_up')}
            </DepositQRCodeMobileContentTitleStyled>
        </DepositQRCodeMobileContentStyled>
        <DepositQRCodeMobileStepsStyled>
            <CashierSteps
                selectedPayment={selectedPayment}
                steps={DEPOSIT_QR_CODE_STEPS}
            />
        </DepositQRCodeMobileStepsStyled>
        <DepositQRCodeMobileSubmitButtonWrapperStyled>
            <Button
                onClick={handleCopyToClipboard}
                variant="primary"
                size="lg"
            >
                <BinIcon name="IcCopy"
                         className={'me-2'}
                         style={{fontSize: '1.3em', fill: 'black'}}/>
                {getLangPath('pix_qr.copy_pix_key')}
            </Button>
        </DepositQRCodeMobileSubmitButtonWrapperStyled>
    </DepositQRCodeMobileStyled>
}

export default DepositQRCodeMobile;
